import type { CSSProperties, ReactNode, HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padding?: number;
}

export function Card({ children, style, padding = 16, ...rest }: CardProps) {
  const merged: CSSProperties = {
    background: '#fff',
    borderRadius: 14,
    padding,
    boxShadow: 'var(--shadow-card)',
    border: 'var(--border-card)',
    ...style,
  };
  return (
    <div {...rest} style={merged}>
      {children}
    </div>
  );
}
